import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import styled from "styled-components";
import VestingVestedAward from "./VestingVestedAward";
import { connect } from "react-redux";
import Moment from "moment";
import { Mobile, Desktop } from "../../../media";
import EmployeeService from "../../../services/Employee.service";
import UnvestedAwardDetailsDialog from "../UnvestedAwardDetailsDialog";
import { Link } from "react-router-dom";
import VestedAwardDetailsDialog from "../stockAwards/VestedAwardDetailsDialog";
import TaxElectionsDialog from "../common/TaxElectionsDialog";
import USFedRateDialog from '../common/USFedRateDialog'
import VestElectionsDialog from '../common/VestElectionsDialog';
import ChangeTaxRateDialog from "../common/ChangeTaxRateDialog";
import FractionalSharesDialog from './FractionalSharesDialog';
import {UserRoles} from '../../../constants'


const Container = styled.section`
  width: 930px;
  padding: 25px 0 21px 0;
  margin: 0 auto;

  // Mobile version.
  @media (max-width: 768px) {
    padding: 24px 16px 24px 16px;
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  > h2 {
    font-family: Lato-Light;
    font-size: 24px;
    font-weight: normal;

    color: #2b2b2b;
    line-height: 28px;
    padding: 0;
    margin: 0;
    padding-bottom: 5px;
    border-bottom: 1px solid #bababa;

    > a {
      font-family: Lato-Regular;
      font-size: 14px;
      color: #1d71bb;
      line-height: 16px;
      text-decoration: none;
      margin-top: 12px;
      float: right;
    }
  }

  > p {
      font-family: Lato-Regular;
      font-size: 14px;
      color: #2b2b2b;

      // Desktop version.
      @media (min-width: 768px) {
        line-height: 22px;
      }

      // Mobile version.
      @media (max-width: 768px) {
        line-height: 17px;
      }
    }

  > ul {
    padding: 0;
    margin: 0;
    display: inline-flex;

    > li {
      display: inline-block;
    }

    > li:nth-child(1),
    > li:nth-child(2) {
      margin-right: 30px;
    }

    // Mobile version.
    @media (max-width: 768px) {
      display: inline-block;

      > li {
        display: inline-block;
        margin-bottom: 22px;
        width: 100%;
      }
    }
  }
`;

export class VestingSummary extends Component {
  constructor(props) {
    super(props);

    var award = null;
    var vest = null;
    var transaction = null;
    if (props.employee.awards.length > 0) {
      award = props.employee.awards[0];
      vest = props.employee.awards[0].vests[0];
      transaction = props.employee.awards[0].transactions[0];
    }

    this.state = {
      vestSummaryDialogVisible: false,
      transactionSummaryDialogVisible: false,
      taxElectionsDialogVisible: false,
      usFedRateDialogVisible: false,
      vestElectionsDialogVisible: false,
      fractionalSharesDialogVisible: false,
      changeTaxRateDialogVisible: false,
      employee: props.employee,
      awardWithVest: { award: award, vest: vest},
      awardWithTransaction: { award: award, vest: transaction},
    };
  }

  selectTransactionEvent = (award_id, vest_id, transaction_id) => {
    this.setState({
      transactionSummaryDialogVisible: true,
      awardWithTransaction: EmployeeService.loadAwardWithTransaction(
        this.state.employee,
        award_id,
        transaction_id
      )
    });
  };

  selectVestEvent = (award_id, vest_id) => {
    this.setState({
      vestSummaryDialogVisible: true,
      awardWithVest: EmployeeService.loadAwardWithVest(
        this.state.employee,
        award_id,
        vest_id
      )
    });
  };

  taxElectionsOnClick = (callback) => {
    this.setState({
        awardIdSelected: null,
        taxElectionsDialogVisible: true
    })
  }

  taxElectionsOnCloseDialog = () => {
    this.setState({
        taxElectionsDialogVisible: false
    })
  }

  taxElectionsOnChangeTaxPayment = () => {
    this.setState({
        taxElectionsDialogVisible: false,
        changeTaxRateDialogVisible: true
    })
  }

  usFedRateOnClick = (callback) => {
    this.setState({
        awardIdSelected: null,
        usFedRateDialogVisible: true
    })
  }

  usFedRateOnCloseDialog = () => {
    this.setState({
        usFedRateDialogVisible: false
    })
  }

  usFedRateOnChangeTaxPayment = () => {
    this.setState({
        usFedRateDialogVisible: false,
        changeTaxRateDialogVisible: true
    })
  }

  vestElectionsOnChangeTaxPayment = () => {
    this.setState({
      vestElectionsDialogVisible: false,
      changeTaxRateDialogVisible: true
    })
  }

  vestElectionsOnChangeDeliveryMethod = () => {
    this.setState({
      vestElectionsDialogVisible: false,
      fractionalSharesDialogVisible: true
    })
  }

  onCloseFractionalSharesDialog = () => {
    this.setState({
      fractionalSharesDialogVisible: false
    })
  }

  vestElectionsOnClick = (vest) => {
    this.setState({
      awardIdSelected: null,
      calendarYear: null,
      vestElectionsDialogVisible: true,
      vest: vest
    })
  }

  vestElectionsOnCloseDialog = () => {
    this.setState({
      vestElectionsDialogVisible: false
    })
  }

  changeTaxRateOnCloseDialog = () => {
      this.setState({
          changeTaxRateDialogVisible: false
      })
  }

  onChangePaymentMethod = (vest) => {
    if (this.props.fractional_mode){
      this.vestElectionsOnClick(vest)
    }
    else {
      this.taxElectionsOnClick(vest)
    }
  }

  render() {
    const { t, employee } = this.props;
    const summary = this.props.summary;
    const locale = this.props.locale;

    const viewOnly = EmployeeService.hasRole(employee.roles, UserRoles.OVERRIDE_FED_TAX_VIEW) ? true : false
    const taxEnable = EmployeeService.hasRole(employee.roles, UserRoles.OVERRIDE_FED_TAX_ENABLE) || viewOnly

    if (
      summary.unvested === null &&
      summary.recent_vested === null &&
      summary.next_vest === null
    ) {
      return (
        <Container
          className="vesting-summary-container"
          aria-labelledby="vestingSummaryHeading"
        >
          <h2 id="vestingSummaryHeading">
            {t("VestingSummary.Title")}
            <Desktop>
              <Link to="/stock-awards" className="link-to-stock-awards">
                {t("VestingSummary.SeeStockAwardsLink")}
              </Link>
            </Desktop>
            <Mobile>
              <Link to="/stock-awards" className="link-to-stock-awards">
                {t("VestingSummary.SeeStockAwardsMobileLink")}
              </Link>
            </Mobile>
          </h2>
          <p>{t("VestingSummary.NoSummary")}</p>
        </Container>
      );
    }

    let remaining_rsu = summary.unvested ? new Intl.NumberFormat(locale).format(
      summary.unvested.remaining_rsu
    ) : 0;
    let shares_transacted = summary.recent_vested ? new Intl.NumberFormat(locale).format(
      summary.recent_vested.shares_transacted
    ) : 0;
    let net_shares = summary.recent_vested ? new Intl.NumberFormat(locale).format(
      summary.recent_vested.net_shares
    ) : 0;
    let shares_vest = summary.next_vest ? new Intl.NumberFormat(locale).format(
      summary.next_vest.shares_vest
    ) : 0;

    let tax_treatment = summary.next_vest ? summary.next_vest.tax_treatment : "";

    return (
      <Container
        className="vesting-summary-container"
        aria-labelledby="vestingSummaryHeading"
      >
        <h2 id="vestingSummaryHeading">
          {t("VestingSummary.Title")}
          <Desktop>
            <Link to="/stock-awards" className="link-to-stock-awards">
              {t("VestingSummary.SeeStockAwardsLink")}
            </Link>
          </Desktop>
          <Mobile>
            <Link to="/stock-awards" className="link-to-stock-awards">
              {t("VestingSummary.SeeStockAwardsMobileLink")}
            </Link>
          </Mobile>
        </h2>
        <ul>
          {summary.unvested && (
            <li>
              <VestingVestedAward
                className="total-unvested-tile"
                title={t("VestingSummary.TotalUnvestedRsusTitle")}
                date={t("VestingSummary.AsOfDate", {
                  date: Moment(summary.unvested.date).format("LL")
                })}
                info={t("VestingSummary.UnvestedRemainingRsuInfo", {
                  remaining_rsu: remaining_rsu
                })}
                footerTop={t("VestingSummary.UnvestedActiveAwardsInfo", {
                  active_awards: summary.unvested.active_awards
                })}
                theme="default"
              />
            </li>
          )}
          {summary.recent_vested && (
            <li>
              <VestingVestedAward
                className="most-recent-vest-date-tile"
                title={t("VestingSummary.MostRecentVestDateTitle")}
                date={Moment(summary.recent_vested.transaction_date).format(
                  "LL"
                )}
                info={t("VestingSummary.RecentVestedRSUVested", {
                  shares_transacted: shares_transacted
                })}
                footerTop={t("VestingSummary.RecentVestedNetSharesInfo", {
                  net_shares: net_shares
                })}
                footerMid={EmployeeService.getBrokers(t, summary.recent_vested.tax_broker_name, summary.recent_vested.net_broker_name, summary.recent_vested.mobile_tax_sale_in)[0]}
                footerBottom={EmployeeService.getBrokers(t, summary.recent_vested.tax_broker_name, summary.recent_vested.net_broker_name, summary.recent_vested.mobile_tax_sale_in)[1]}
                footer={EmployeeService.getBrokersDisplay(t, summary.recent_vested.tax_broker_name, summary.recent_vested.net_broker_name, summary.recent_vested.mobile_tax_sale_in)}
                onTileClicked={this.selectTransactionEvent}
                theme="default"
                events={summary.recent_vested.events}
                selectVestEvent={this.selectTransactionEvent}
              />
            </li>
          )}
          {summary.next_vest && (
            <li>
              <VestingVestedAward
                className="next-vest-date-tile"
                title={t("VestingSummary.NextVestDateTitle")}
                date={Moment(summary.next_vest.next_vest_date).format("LL")}
                info={t("VestingSummary.NextVestSharesVestInfo", {
                  shares_vest: shares_vest
                })}
                footerTop={t("TaxTreatment." + tax_treatment)}
                footerMid={EmployeeService.getBrokers(t, summary.next_vest.tax_broker_name, summary.next_vest.net_broker_name, summary.next_vest.mobile_tax_sale_in)[0]}
                footerBottom={EmployeeService.getBrokers(t, summary.next_vest.tax_broker_name, summary.next_vest.net_broker_name, summary.next_vest.mobile_tax_sale_in)[1]}
                footer={EmployeeService.getBrokersDisplay(t, summary.next_vest.tax_broker_name, summary.next_vest.net_broker_name, summary.next_vest.mobile_tax_sale_in)}
                theme="default"
                events={summary.next_vest.events}
                selectVestEvent={this.selectVestEvent}
              />
            </li>
          )}
        </ul>
        <UnvestedAwardDetailsDialog
          employee={employee}
          visible={this.state.vestSummaryDialogVisible}
          award={this.state.awardWithVest.award}
          vest={this.state.awardWithVest.vest}
          broker={this.state.awardWithVest.award.tax_broker}
          brokers={EmployeeService.getBrokers(t, this.state.awardWithVest.award.tax_broker.name, this.state.awardWithVest.award.net_broker.name, this.state.awardWithVest.award.mobile_tax_sale_in)}
          done={() => this.setState({ vestSummaryDialogVisible: false })}
          onChangePaymentMethod={this.onChangePaymentMethod}
        />
        <VestedAwardDetailsDialog
          visible={this.state.transactionSummaryDialogVisible}
          brokers={EmployeeService.getBrokers(t, this.state.awardWithTransaction.award.tax_broker.name, this.state.awardWithTransaction.award.net_broker.name, this.state.awardWithTransaction.award.mobile_tax_sale_in)}
          onCloseDialog={() =>
            this.setState({ transactionSummaryDialogVisible: false })
          }
          award={this.state.awardWithTransaction.award}
          transaction={this.state.awardWithTransaction.transaction}
        />
        <TaxElectionsDialog
          vest={this.state.awardWithVest.vest}
          visible={this.state.taxElectionsDialogVisible}
          onChangeTaxPayment={this.taxElectionsOnChangeTaxPayment}
          onCloseDialog={this.taxElectionsOnCloseDialog}
        />
        <USFedRateDialog
          vest={this.state.awardWithVest.vest}
          visible={this.state.usFedRateDialogVisible}
          onChangeTaxPayment={this.usFedRateOnChangeTaxPayment}
          onCloseDialog={this.usFedRateOnCloseDialog}
        />
        <VestElectionsDialog
          visible={this.state.vestElectionsDialogVisible}
          onChangeTaxPayment={this.vestElectionsOnChangeTaxPayment}
          onChangeDeliveryMethod={this.vestElectionsOnChangeDeliveryMethod}
          onCloseDialog={this.vestElectionsOnCloseDialog}
          awardIdSelected={this.state.awardIdSelected}
          vest={this.state.vest}
          calendarYear={this.state.calendarYear}
        />
        {taxEnable &&
          <ChangeTaxRateDialog
          visible={this.state.changeTaxRateDialogVisible}
          onCloseDialog={this.changeTaxRateOnCloseDialog}
          awardIdSelected={this.state.awardIdSelected}
          calendarYear={this.state.calendarYear}
          viewType={this.state.selectedOptionValue}
          viewOnly = {viewOnly}
          key={Date.now()}
        />
        }
        <FractionalSharesDialog
          employee={employee}
          vests={EmployeeService.getUpcomingVests(employee.awards)}
          visible={this.state.fractionalSharesDialogVisible}
          onCloseDialog={this.onCloseFractionalSharesDialog}
        />


      </Container>
    );
  }
}

const mapState = state => ({
  employee: state.employee,
  summary: state.employee.summary,
  locale: state.employee.language,
  fractional_mode: state.static_content.fractional_mode
});

export default connect(mapState)(withTranslation("translations")(VestingSummary));
